/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import CommonSelect from "./CommonSelect";
import CustomInput from "./CustomInput";
import SubscriptionImage from "./SubscriptionImage";
import {
  createZohoSubscription,
  getSubscriptionCityList,
  getSubscriptionCountriesList,
  getSubscriptionStateList,
} from "../../service/ZohoPlanService";
import moment from "moment";
import ZohoCouponsModal from "./ZohoCouponsModal";
import LoginWarningModal from "./LoginWarningModal";
import { useAccount } from "../../component/context/AccountProvider";
import { getGST } from "../../utils/zohoHelper";
import { toast } from "react-toastify";
import {getMyDetails} from "../../service/myDeatils"

const PlanTypeConst = [
  { title: "Indvidual", value: "individual" },
  { title: "Firm", value: "law_firm" },
  { title: "Enterprise", value: "enterprise" },
];
// const user_type = "enterprise"

const ZohoPlanList = ({ selectedPlans, setSelectedPlans }) => {

  const { plan_code, price_brackets, user_type, tenure, max_user } =
    selectedPlans || {};
  // const { userDetails } = useAccount() || {};
  const [userDetails, setUserDetails] = useState({});
  const { email, first_name, last_name, phone, salutation, organisation } =
    userDetails || {};
  //   const navigate = useNavigate();
  const [subscriptionFormValue, setSubscriptionFormValue] = useState({
    billingAddress: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
    gst: "",
    coupon_code: "",
  });
  const [countriesList, setCountriesList] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [showZohoCouponModal, setShowZohoCouponModal] = useState(false);
  const [discount, setDiscount] = useState({
    couponCode: null,
    couponAmountInPercent: 0,
    couponType: "",
  });
  const [licenseQuantity, setlicenseQuantity] = useState(1);
  const [manualTypeCoupon, setManualTypeCoupon] = useState("");
  console.log(
    selectedPlans,
    subscriptionFormValue,
    countriesList,
    "selectedPlans"
  );

  useEffect(() => {
    async function loadUser() {
      try {
        const resp = await getMyDetails();
        setUserDetails(resp);
      } catch (err) {
        console.error("Failed to load user details:", err);
      }
    }

    loadUser();
  }, []);

  const handleSubscribe = async () => {
    try {
      const todayDate = moment().format("YYYY-MM-DD");
      const {
        billingAddress,
        country,
        state,
        city,
        zipCode,
        gst,
        coupon_code,
      } = subscriptionFormValue;
      const data = await createZohoSubscription({
        customer: {
          display_name: organisation?.id
            ? organisation?.name
            : `${first_name} ${last_name}`,
          salutation: salutation,
          first_name: first_name,
          last_name: last_name,
          email: email,
          company_name: organisation?.id ? organisation?.name : "",
          phone: phone,
          billing_address: {
            attention: billingAddress,
            street: billingAddress,
            city: city,
            state: state,
            country: country,
            zip: zipCode,
            fax: "",
          },
          shipping_address: {
            attention: "",
            street: "",
            city: "",
            state: "",
            country: "",
            zip: "",
          },
          payment_terms: 0,
          payment_terms_label: "Due On Receipt",
          currency_code: "INR",
          is_taxable: true,
          place_of_contact: "",
          gst_no: gst,
          gst_treatment: "business_gst",
        },
        plan: {
          plan_code: plan_code,
          quantity: licenseQuantity,
        },
        addons: [],
        starts_at: todayDate,
        coupon_code: discount.couponCode === null ? "" : discount.couponCode,
        redirect_url: `${window.location.origin}/subscription`,
        // redirect_url: "https://dev-dealbase.lexops.co/subscription",
      });
      console.log(data, "newData");
      if (data?.data?.hostedpage?.url) {
        window.open(data?.data?.hostedpage?.url);
      } else {
        if (data?.data?.code) {
          toast.error(data?.data?.message || "Something went wrong");
        }
      }

      console.log(data?.data, "newDtaa data");
    } catch (error) {
      console.log(error, "newData");
    }
  };

  const fetchAllCountries = async () => {
    try {
      const data = await getSubscriptionCountriesList();
      if (Array.isArray(data)) {
        const newData = data.map((item) => {
          return { name: item?.name, value: item?.name, id: item?.id };
        });

        setCountriesList(newData);
      }
    } catch (error) { }
  };

  const fetchAllStates = async (countryName) => {
    try {
      const countryId = countriesList.find(
        (item) => item?.name === countryName
      )?.id;
      const data = await getSubscriptionStateList(countryId);
      if (Array.isArray(data)) {
        const newData = data.map((item) => {
          return { name: item?.name, value: item?.name, id: item?.id };
        });

        setStatesList(newData);
      }
    } catch (error) { }
  };

  const fetchAllCity = async (stateName) => {
    try {
      const stateId = statesList.find((item) => item?.name === stateName)?.id;
      const data = await getSubscriptionCityList(stateId);
      if (Array.isArray(data)) {
        const newData = data.map((item) => {
          return { name: item?.name, value: item?.name };
        });

        setCityList(newData);
      }
    } catch (error) { }
  };
  const handleFormvalue = (key, value) => {
    setSubscriptionFormValue((state) => {
      return { ...state, [key]: value };
    });
  };

  useEffect(() => {
    fetchAllCountries();
  }, []);
  useEffect(() => {
    if (subscriptionFormValue["country"]) {
      fetchAllStates(subscriptionFormValue["country"]);
    }
  }, [subscriptionFormValue["country"]]);

  useEffect(() => {
    if (subscriptionFormValue["state"]) {
      fetchAllCity(subscriptionFormValue["state"]);
    }
  }, [subscriptionFormValue["state"]]);

  const calculateDiscount = () => {
    if (
      discount.couponCode &&
      discount.couponCode !== null &&
      discount.couponAmountInPercent
    ) {
      const subTotal = price_brackets?.[0]?.price;
      let totalDiscount = 0;
      if (discount?.couponType === "flat") {
        totalDiscount = discount.couponAmountInPercent;
      } else {
        totalDiscount = (subTotal * discount.couponAmountInPercent) / 100;
      }

      return totalDiscount;
    } else {
      return 0;
    }
  };

  const subTotal = price_brackets?.[0]?.price * licenseQuantity;

  const totalDiscount = calculateDiscount();
  const totalGst = getGST(subTotal - totalDiscount);
  const totalAmount = subTotal + totalGst - totalDiscount;
  const token = localStorage.getItem("token");
  console.log(subTotal, totalGst, selectedPlans, discount, "selectedPlans --2");
  return (
    <>
      <LoginWarningModal
        openModal={token === "null" || token === null}
        handleCloseModal={() => setSelectedPlans(null)}
      />
      {showZohoCouponModal && (
        <ZohoCouponsModal
          open={showZohoCouponModal}
          onClose={() => setShowZohoCouponModal(false)}
          planCode={plan_code}
          onApplyCoupon={(coupon) => {
            console.log(coupon, "couponData");
            setDiscount({
              couponCode: coupon?.coupon_code || null,
              couponAmountInPercent: coupon?.discount_value,
              couponType: coupon?.discount_type,
            });

            setShowZohoCouponModal(false);
          }}
          selectedPlan={selectedPlans}
        />
      )}

      <div className="subscription-container">
        <div className="subscription-box">
          <div className="zoho-checkout-header">
            <h3>Subscription</h3>
            <button onClick={() => setSelectedPlans(null)}>
              {/* <CrossIcon /> */}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="2"
                  y="2.70703"
                  width="1"
                  height="28"
                  rx="0.5"
                  transform="rotate(-45 2 2.70703)"
                  fill="#303030"
                />
                <rect
                  x="21.7988"
                  y="2"
                  width="1"
                  height="28"
                  rx="0.5"
                  transform="rotate(45 21.7988 2)"
                  fill="#303030"
                />
              </svg>
            </button>
          </div>

          <div className="plan-section">
            <h4 className="plan-page-title">Your plan</h4>
            <div className="plan-info">
              <div className="left-side">
                <h4>
                  For <span>{PlanTypeConst?.find((_) => _?.value === user_type)?.title}</span>
                </h4>
                <h4 className="licence-type">( {selectedPlans?.license_type} License )</h4>
              </div>
              {user_type !== "individual" && (
                <div>
                  <h4>Enter No of Licenses</h4>
                  <div className="license-input">
                    <button
                      onClick={() =>
                        licenseQuantity > 1 &&
                        setlicenseQuantity(licenseQuantity - 1)
                      }
                    >
                      -
                    </button>
                    <h4>{licenseQuantity}</h4>
                    <button
                      onClick={() => setlicenseQuantity(licenseQuantity + 1)}
                    >
                      +
                    </button>
                  </div>
                  <h4 className="text-right mt-1">(Max-{max_user})</h4>
                </div>
              )}
            </div>
          </div>

          <div className="billing-section">
            <h4>Billing Cycle</h4>
            <div className="billing-options">
              <button
                className={'selected'}
                style={{ pointerEvents: 'none', textTransform: 'capitalize' }}
              >
                {tenure}
              </button>
              {/* <button
                className={tenure === "annual" ? "selected" : "not-selected"}
              >
                Yearly
              </button> */}
            </div>
          </div>

          <div className="billing-section">
            <h4>Billing Address</h4>
            <input
              className="input-field"
              placeholder="Billing Address *"
              onChange={(e) =>
                handleFormvalue("billingAddress", e.target.value)
              }
              value={subscriptionFormValue["billingAddress"]}
            />
            <div className=" zoho-checkout-address-section">
              <CommonSelect
                label="Country"
                options={countriesList}
                onChange={(e) => handleFormvalue("country", e.target.value)}
              />
              <CommonSelect
                label="State"
                options={statesList}
                onChange={(e) => handleFormvalue("state", e.target.value)}
              />
              <CommonSelect
                label="City"
                options={cityList}
                onChange={(e) => handleFormvalue("city", e.target.value)}
              />
              <CustomInput
                label="Zip Code"
                placeholder="Zip Code"
                onChange={(e) => handleFormvalue("zipCode", e.target.value)}
                value={subscriptionFormValue["zipCode"]}
              />
            </div>
          </div>

          <div className="details-section">
            <h4>Additional Details</h4>
            <CustomInput
              label="GST"
              placeholder="GST (Optional)"
              onChange={(e) => handleFormvalue("gst", e.target.value)}
              value={subscriptionFormValue["gst"]}
            />

            <div className="coupon-section">
              <CustomInput
                label="Coupon Code"
                placeholder="Apply Coupon Code"
                onChange={(e) => setManualTypeCoupon(e.target.value)}
                value={manualTypeCoupon || discount.couponCode || ""}
              />
              {manualTypeCoupon ? (
                <>
                  <div className="custom-discount-apply-button">
                    <button
                      className="custom-discount-clear-btn"
                      onClick={() => setManualTypeCoupon("")}
                    >
                      Clear
                    </button>
                    <button className="custom-discount-apply-btn">Apply</button>
                  </div>
                </>
              ) : (
                <>
                  {discount?.couponCode ? (
                    <button
                      className="clear"
                      onClick={() =>
                        setDiscount({
                          couponCode: null,
                          couponAmountInPercent: 0,
                        })
                      }
                    >
                      Remove Coupon
                    </button>
                  ) : (
                    <button
                      className="custom-discount-apply-btn"
                      onClick={() => setShowZohoCouponModal(true)}
                    >
                      View Coupon
                    </button>
                  )}
                </>
              )}
            </div>
          </div>

          <div className="pricing-summary">
            <div className="summary-item">
              <h4>Sub Total</h4>
              <h4>
                ₹{subTotal} / {tenure}
              </h4>
            </div>
            {totalDiscount ? (
              <div className="summary-item">
                <h4 className="discount">Discount</h4>
                <h4 className="discount">-₹{totalDiscount}</h4>
              </div>
            ) : null}
            <div className="summary-item">
              <h4>GST (18%)</h4>
              <h4>₹{totalGst}</h4>
            </div>
            <div className="summary-item">
              <h4>Total</h4>
              <h4>
                ₹{totalAmount} / {tenure}
              </h4>
            </div>
          </div>

          <button className="purchase-button" onClick={handleSubscribe}>
            Agree & Purchase
          </button>
        </div>

        <div className="subscription-image">
          <SubscriptionImage />
        </div>
      </div>
    </>
  );
};

export default ZohoPlanList;
